// Non-mic browser permissions (geolocation and similar) stay deferred on
// /survey until a real location question. A voice turn or typed answer is
// not that question and must not raise the location gate over the interview.
// Microphone access may still be requested when voice starts.

export const SURVEY_NON_MIC_PERMISSIONS_EVENT = "dople:survey-non-mic-permissions";

const LOCATION_QUESTION_PATTERNS = [
  /\bwhere are you (?:right now|currently|located)\b/i,
  /\buse your (?:current )?location\b/i,
  /\bshare your (?:current )?location\b/i,
  /\bcurrent location\b/i,
  /\bcity do you (?:currently )?live\b/i,
  /\bwhat city do you (?:currently )?live in\b/i,
  /\bhome city\b/i,
];

let released = false;

export function isSurveyPath(pathname = "") {
  const path = String(pathname || "");
  return path === "/survey" || path.startsWith("/survey/");
}

export function surveyNonMicPermissionsReleased() {
  return released;
}

export function shouldDeferNonMicPermissions(pathname = "") {
  return isSurveyPath(pathname) && !released;
}

export function promptAsksForLocation(prompt = "") {
  const text = String(prompt || "").replace(/\s+/g, " ").trim();
  if (!text) return false;
  return LOCATION_QUESTION_PATTERNS.some((pattern) => pattern.test(text));
}

export function shouldReleaseSurveyNonMicPermissions(reason = "", prompt = "") {
  const normalized = String(reason || "");
  if (normalized === "location_question") return true;
  if (normalized === "voice_turn" || normalized === "typed_fallback") {
    return promptAsksForLocation(prompt);
  }
  return false;
}

export function releaseSurveyNonMicPermissions(reason = "", prompt = "") {
  if (released) return false;
  if (!shouldReleaseSurveyNonMicPermissions(reason, prompt)) return false;
  released = true;
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(SURVEY_NON_MIC_PERMISSIONS_EVENT, {
      detail: { reason: String(reason || "") },
    }));
  }
  return true;
}

export function resetSurveyNonMicPermissions() {
  released = false;
}
